import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { RequestsServices } from '../../../services/requests.service';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { PageBase } from '../../../page.base';
import { ToasterService } from '../../../services/toaster.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.scss'],
  providers: [RequestsServices, StorageService, UserService],
  encapsulation: ViewEncapsulation.None
})

export class OfferComponent extends PageBase implements OnInit {

  categories = [];
  config;
  establishment: any = { categorySelected: [] };
  isLoading;
  offer = null;
  offerSlug = null;

  constructor(
    private translate: TranslateService,
    private toaster: ToasterService,
    private request: RequestsServices,
    private route: ActivatedRoute,
    private router: Router,
    private storage: StorageService,
    private userService: UserService
  ) {

    super();

    const languageCurrent = navigator.language;
    translate.addLangs(['en', 'pt-br']);
    translate.setDefaultLang('en');
    languageCurrent === 'pt-BR' ? translate.use('pt-br') : translate.use('en');

    this.config = {
      fillEmptyBlocks: false,
      allowedContent: false,
      forcePasteAsPlainText: true,
      pasteFilter: 'plain-text',
      clipboard_defaultContentType: 'text',
      enterMode: 1, // On enter key press: CKEDITOR.ENTER_BR = 2, CKEDITOR.ENTER_P = 1
      toolbarGroups: [
        { name: 'basicstyles', groups: ['basicstyles'] },
        { name: 'links', groups: ['links'] },
        { name: 'paragraph', groups: ['list', 'indent'] },
        { name: 'blocks', groups: ['blocks', 'align'] },
        { name: 'cleanup', groups: ['cleanup'] },
        { name: 'undo', groups: ['undo'] },
      ],
      removeButtons: 'Subscript,Anchor,Superscript,CreateDiv',
      removePlugins: 'elementspath',
      extraPlugins: 'divarea'
    };

    this.offerSlug = this.route.snapshot.paramMap.get('offerSlug');
  }

  public ngOnInit(): void {
    window.scrollTo(0, 0);
    this.getCategories();

    const establishmentAccount = this.userService.getLoggedAccount();
    const typeBusiness = this.userService.getTypeAccount();
    if (typeBusiness === 'establishment' && establishmentAccount) {
      this.getEstablishment(establishmentAccount['id']);
    } else {
      this.toaster.error('Aviso!', 'Conta de negócio inválida', false, 4000);
      this.router.navigate(['/home']);
    }

  }

  onEditorReady(e) {
    const blockTags = ['div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'li', 'blockquote', 'ul', 'ol', 'table', 'thead',
      'tbody', 'tfoot', 'td', 'th', 'br'];

    for (let i = 0; i < blockTags.length; i++) {
      e.editor.dataProcessor.writer.setRules(blockTags[i], {
        indent: false,
        breakBeforeOpen: false,
        breakAfterOpen: false,
        breakBeforeClose: false,
        breakAfterClose: false
      });
    }
  }

  private getEstablishment(establishmentId): void {
    this.request.get({ path: 'establishments', pathParam: `/${establishmentId}` }).then((establishment) => {
      this.establishment = establishment;
      this.offer = (this.offerSlug === 'allya')
        ? establishment.offer
        : establishment.applications_offer.find(el => el.application_slug === this.offerSlug);

      if (!this.offer || this.offer.state === 'blocked') {
        this.router.navigate(['/negocio/proposta/']);
      }

      this.setCategory();
    });
  }

  private getCategories(): void {
    this.request.get({ path: 'categories' }).then((res) => {
      const categories = res || [];
      categories.forEach((category) => {
        this.categories.push({
          id: category.id,
          text: category.name,
          title_offer_sample: category.title_offer_sample,
          text_offer_sample: category.text_offer_sample,
          tags: category._tags
        });
      });
      if (this.establishment && this.establishment['categoryId']) {
        this.setCategory();
      }
    });
  }

  public getOfferTitleSample(): string {
    return this.establishment['categorySelected'] && this.establishment['categorySelected'].length > 0
      ? this.establishment['categorySelected'][0]['title_offer_sample'] : '';
  }

  public getOfferTextSample(): string {
    return this.establishment['categorySelected'] && this.establishment['categorySelected'].length > 0
      ? this.establishment['categorySelected'][0]['text_offer_sample'] : '';
  }

  private setCategory() {
    this.categories.forEach((item) => {
      if (item.id.toString() === this.establishment['categoryId'].toString()) {
        this.establishment['categorySelected'] = [item];
      }
    });
  }

  public updateEstablishment(): void {
    if (!this.validateModel()) { return; }

    const establishmentData = {};
    const { applications_offer, id } = this.establishment;

    if (this.offerSlug === 'allya') {
      establishmentData['offer'] = this.offer;
    } else {
      establishmentData['applications_offer'] = applications_offer
        .map(el => el.application_slug === this.offer.application_slug ? this.offer : el);
    }

    this.isLoading = true;
    this.request.patch('establishments', establishmentData, '', `/${id}`).then((establishment) => {
      this.isLoading = false;
      if (establishment) {
        this.toaster.info('Sucesso', 'Proposta salva com sucesso.', true, 2000);
        this.userService.requestAccountConfig();
      }
    });
  }

  private validateModel(): boolean {
    if (!this.offer.allya_offer) {
      if (!this.offer.title) {
        this.toaster.info('Atenção', 'Preencha o título.', false, 2000);
        return false;
      }

      if (!this.offer.term) {
        this.toaster.info('Atenção', 'Preencha a proposta.', false, 2000);
        return false;
      }

      if (!this.offer.contact.name) {
        this.toaster.info('Atenção', 'Preencha o nome do contato.', false, 2000);
        return false;
      }

      if (!this.offer.contact.phone) {
        this.toaster.info('Atenção', 'Preencha o telefone do contato.', false, 2000);
        return false;
      }
    }

    return true;
  }
}
